import React, { Component } from 'react';
import {
    Link,
    Redirect
} from "react-router-dom";
import { Formik } from 'formik';
import _ from 'lodash';
import config from '../config';
import JsonEditorComponent from '../JsonEditorComponent'
import {AuthContext} from "../context/auth";
import fetcher from "../context/fetcher";
import {downloadFile, readFileAsync} from "../components/ImportExport";

export default class UniversalCollectionView extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        let {collectionName } = this.props.match.params;
        this.collectionName = collectionName;

        this.keys = [];
        this.state = {query: {}};
        this.init = this.init.bind(this);
        this.remove = this.remove.bind(this);
        this.init();
    }

    async init(query)  {
        fetcher(`${config.API()}dbtable/${this.collectionName}?` + new URLSearchParams(Object.assign({
            page: 0
        }, query)))
        .then(response => response.json())
        .then(data => {
            this.setState({query: query, objs: data.items, total: data.total})
        });
    }

    remove = (eventId) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if(!isOk)
                return;
            fetcher(`${config.API()}dbtable/${this.collectionName}/remove/${eventId}`,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body:"{}"
            })
            .then(response => response.json())
            .then(data => {
                let objs = this.state.objs;
                _.remove(objs, x => x._id == eventId)
                this.setState({objs})
            });
        }
    }

    linkToEdit = (eventId) => {
        return () => {
            this.setState({redirect: `/view/${this.collectionName}/${eventId}`});
        }
    }


    render() {

        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }


        const query = new URLSearchParams(this.props.location.search);
        let newQuery = {
            page: query.get("page") || 0
        }

        if (!_.isEqual(newQuery, this.state.query)) {
            this.init(newQuery);
            return (<div></div>);
        }

        let pages = []
        let page = parseInt(this.state.query.page) || 0
        let lastPage = Math.floor(this.state.total / 100)

        if(page == 0) {
            pages.push(page)
            if(page+1 <= lastPage)
                pages.push(page+1)
            if(page+2 <= lastPage)
                pages.push(page+2)
        }else if(page == lastPage){
            if(page-2 >=0)
                pages.push(page-2)
            if(page-1 >=0)
                pages.push(page-1)
            pages.push(page)
        }else{
            if(page-1 >=0)
                pages.push(page-1)
            pages.push(page)
            if(page+1 <= lastPage)
                pages.push(page+1)
        }

        return (
            <div>
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> {this.collectionName} </h2>
                </div>
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <div className="r p-2 pr-4">
                                <ul className="pagination">
                                    <li className={"page-item " + (page == 0 ? "disabled" : "")}>
                                        {page != 0 && <Link className="page-link" to={"/users?"+ new URLSearchParams(Object.assign(newQuery, {page:page-1}))}>Previous</Link>}
                                        {page == 0 && <span className="page-link">Previous</span>}
                                    </li>
                                    { pages.map((p,i) =>
                                        <li key={`p`+p} className={`page-item ${page == p ? "active" : ""}`}>
                                            <Link className="page-link" to={"/users?" + new URLSearchParams(Object.assign(newQuery, {page:p}))}>{ p+1 }</Link>
                                        </li>
                                    )}
                                    <li className={"page-item " + (page == lastPage ? "disabled" : "")}>
                                        {page != lastPage && <Link className="page-link" to={"/users?"+ new URLSearchParams(Object.assign(newQuery, {page:page+1}))}>Next</Link>}
                                        {page == lastPage && <span className="page-link">Next</span>}
                                    </li>
                                </ul>
                            </div>
                            <div className="r p-2 pr-4 pt-3">Showing {page+1} to {lastPage+1} of {this.state.total} users</div>
                        </div>
                    </div>
                    <div className="table-responsive">
                        <table className="dataTable table table-align-middle table-bordered table-sm" width="100%"
                               cellSpacing="0">
                            <thead>
                            <tr>
                                <th>Name</th>
                                {this.keys.map((k) => <th className="text-capitalize">{k}</th>)}
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.objs && this.state.objs.map((x,i) =>
                                <tr key={x._id}>
                                    <td>{x.name || x.title}</td>
                                    {this.keys.map((k) => <td>{x[k]}</td>)}
                                    <td>
                                        <button className="btn btn-outline-danger btn-circle btn-sm" onClick={this.remove(x._id)} ><i className="fa fa-remove"></i></button>
                                        <button className="btn btn-outline-primary btn-circle btn-sm" onClick={this.linkToEdit(x._id)} ><i className="fa fa-edit"></i></button>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="r mt-3">
                        <button onClick={this.linkToEdit("new")} className="btn btn-icon btn-primary ml-1"><span className="fas fa-fw fa-plus-square"></span> Add</button>
                    </div>
                </div>
            </div>

            </div>
        );
    }
}
